import { BaseComponent } from '../../base-component';

export class ComplaintToolComponent extends BaseComponent {
    public rootSelector = '.js_pdp_complaint-tool';
    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const complaintToolUrl = this.loadComplaintToolUrl();
        if (!!complaintToolUrl) {
            this.getRootElement()
                .querySelector('.js_pdp_complaint-tool__text-wrapper')
                ?.addEventListener('click', () => (window.location.href = complaintToolUrl));
        }
    }

    private loadComplaintToolUrl(): string | undefined {
        const base64EncodedComplaintUrl = this.getRootElement().getAttribute('data-complaint-url');
        if (!base64EncodedComplaintUrl) {
            this.logError({
                message: 'complaint tool error: no complaint url',
            });
            return;
        }
        return atob(base64EncodedComplaintUrl);
    }
}
